import { Component } from 'react'
import type { ReactNode, ErrorInfo } from 'react'
import { Text } from 'components'
import type { SectionErrorBoundaryProps } from '../interfaces'

interface SectionErrorBoundaryState {
  hasError: boolean
}

/**
 * Isolates a dashboard section. If a child throws while rendering, only this
 * section degrades to a message — the rest of the screen keeps working.
 */
export class SectionErrorBoundary extends Component<SectionErrorBoundaryProps, SectionErrorBoundaryState> {
  state: SectionErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(): SectionErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[ManagerDashboard] Section error:', error, info)
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <Text color='dimmed' size='sm' role='alert'>
          {this.props.fallbackMessage}
        </Text>
      )
    }
    return this.props.children
  }
}
